var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeadlift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 31.5V30.5H5.00011V26H6.00011V30.5H7.50011V26H8.50011V30.5H10.0001V26H11.0001V30.5H35V26H36V30.5H37.5V26H38.5V30.5H40V26H41V30.5H42.0001V31.5H41V36H40V31.5H38.5V36H37.5V31.5H36V36H35V31.5H11.0001V36H10.0001V31.5H8.50011V36H7.50011V31.5H6.00011V36H5.00011V31.5H4Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 30.5V31.5H42.0001V30.5H4ZM35 26H36V36H35V26ZM37.5 26H38.5V36H37.5V26ZM40 26H41V36H40V26ZM11.0001 26V36H10.0001V26H11.0001ZM8.50011 26H7.50011V36H8.50011V26ZM6.00011 26H5.00011V36H6.00011V26Z",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9C19 9 19 15 23 15C27 15 27 9 23 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 17C26.5 16.5 19.5 16.5 19.5 17V26.5L16 25.5V36C16 36.5 18 36.5 18 36V28.5C18 28.5 21 29 23 29C25 29 28 28.5 28 28.5L28 36C28 36.5 30 36.5 30 36L30 25.5L26.5 26.5L26.5 17Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9C19 9 19 15 23 15C27 15 27 9 23 9Z",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 17C26.5 16.5 19.5 16.5 19.5 17V26.5L16 25.5V36C16 36.5 18 36.5 18 36V28.5C18 28.5 21 29 23 29C25 29 28 28.5 28 28.5L28 36C28 36.5 30 36.5 30 36L30 25.5L26.5 26.5L26.5 17Z",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30C34.5 30 27 17 26.5 17V19.5L32.5 30H34.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 30L19.5 19.5V17C19 17 11.5 30 11.5 30H13.5Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 30C34.5 30 27 17 26.5 17V19.5L32.5 30H34.5Z",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 30L19.5 19.5V17C19 17 11.5 30 11.5 30H13.5Z",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadlift);
export default __webpack_public_path__ + "static/media/deadlift.5bea07d01c247e60639faf0aae58bbe2.svg";
export { ForwardRef as ReactComponent };